import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { consumeSuperuserSessionHandoff } from './sessionHandoff';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ApolloProvider from './ApolloProvider';

consumeSuperuserSessionHandoff();

ReactDOM.render(
  <ApolloProvider>
    <App />
  </ApolloProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
